import { is_elementor_edit, get_offset } from 'js/utils';
import '@fontsource/nunito-sans/800.css';
import '@fontsource/nunito-sans/900.css';
import './technology.scss';

document.addEventListener('DOMContentLoaded', init);
function init(){
    if( is_elementor_edit() ) return;
    setTimeout(init_section_ai, 1000)
}

function init_section_ai(){
    
    const container = document.querySelector('.section_ai');
    if( !container ) return;

    const offset_top = get_offset(container).top;
    const activate_point = offset_top - 150;
    const y_start = offset_top;
    const y_end = offset_top + container.offsetHeight;
    
    let header_class_activated = false;
    let section_class_activated = false;

    const update_section = ()=>{

        // container.classList[ scrollY >= activate_point ? 'add' : 'remove']('activate')

        if( scrollY >= activate_point ) {
            if( !section_class_activated ) {
                container.classList.add('activate')
                section_class_activated = true;
            }
        } else {
            if( section_class_activated ) {
                container.classList.remove('activate')
                section_class_activated = false;
            }
        }
        
    }

    const update_header = ()=>{

        const in_section = scrollY >= y_start && scrollY <= y_end;
        // document.body.classList[ in_section ? 'add' : 'remove']('in_ai_section')

        if( in_section ) {
            if( !header_class_activated ) {
                document.body.classList.add('set_header_transparent')
                header_class_activated = true;
            }
        } else {
            if( header_class_activated ) {
                document.body.classList.remove('set_header_transparent')
                header_class_activated = false;
            }
        }
    }

    const detect_onscreen = ()=>{
        update_section();
        update_header();
    }
    detect_onscreen();
    
    document.addEventListener('scroll', detect_onscreen, {passive: true})
}